<template>
  <div :class="inputClass">


    <input type="checkbox"
           :id="showPasswordInputId"
           class="show-password"
    >

    <label @click="toggleShowPassword()" :for="showPasswordInputId"
           class="Control-label Control-label--showPassword">

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="32" height="32" class="svg-toggle-password"
           title="Toggle Password Security">
        <title>Hide/Show Password</title>
        <path
            d="M24,9A23.654,23.654,0,0,0,2,24a23.633,23.633,0,0,0,44,0A23.643,23.643,0,0,0,24,9Zm0,25A10,10,0,1,1,34,24,10,10,0,0,1,24,34Zm0-16a6,6,0,1,0,6,6A6,6,0,0,0,24,18Z"/>
        <rect x="20.133" y="2.117" height="44" transform="translate(23.536 -8.587) rotate(45)" class="closed-eye"/>
        <rect x="22" y="3.984" width="4" height="44" transform="translate(25.403 -9.36) rotate(45)" style="fill:#fff"
              class="closed-eye"/>
      </svg>
    </label>

    <input type="password"
           :id="passwordInputId"
           :placeholder="$t('authentication_general.password_placeholder')"
           @keyup="handleInput"
           class="ControlInput d-inline-block w-100 rounded-pill ControlInput--password"
    >


  </div>
</template>

<script>
import {defineComponent} from 'vue'
import {generateRandomString} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default defineComponent({
  name: "PasswordFormInput1",
  computed: {
    inputClass() {
      return `show-password-${generateRandomString()}`
    },
    passwordInputId() {
      return `password-${generateRandomString()}`
    },
    showPasswordInputId() {
      return `show-password-${generateRandomString()}`
    }
  },
  methods: {
    generateRandomString,
    toggleShowPassword() {
      const passwordInput = document.querySelector(` .${this.inputClass}  #${this.passwordInputId}`);
      const showPasswordCheckbox = document.querySelector(` .${this.inputClass}  #${this.showPasswordInputId}`);

      passwordInput.type = showPasswordCheckbox.checked ? 'password' : 'text';


    },
    handleInput(e) {
      this.$emit('update:modelValue', e.target.value)
    }
  }
})
</script>

<style scoped>

.Control-label {
  transition: color 300ms ease;
}

.ControlInput {
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(197, 193, 192, 0) inset;
  color: #6d6665;
  margin: 0.8em 0;
  padding: 0.6em 0.6em;
  transition: box-shadow 300ms ease-out;
}

.ControlInput:hover {
  box-shadow: 0 1px 3px rgba(197, 193, 192, 0.4) inset;
}

.ControlInput:focus {
  outline: #2bbee7 auto 3px;
}


.ControlInput--password {
  order: 0;
  border: 1px solid #ced4da;
  padding-right: 50px;
}

.Control-label--password {
  order: -1;
  margin-bottom: -32px;
}

.Control-label--showPassword {
  width: 32px;
  position: relative;
  text-align: right;
  margin-left: -36px;
}

.Form-submit:active .Button-spinner {
  opacity: 1;
}

.ControlInput--email:valid ~ .ControlInput--password:valid ~ .Form-submit {
  cursor: pointer;
  pointer-events: auto;
  opacity: 1;
}


.show-password {
  display: none;
}

.show-password:checked ~ .ControlInput--password {


}

.show-password:checked ~ .Control-label--showPassword .svg-toggle-password .closed-eye {
  opacity: 1;
  transition: opacity 300ms ease, height 400ms ease;
  width: 4px;
  height: 44px;
}

.svg-toggle-password {
  fill: rgba(0, 142, 214, 0.5);
}

.svg-toggle-password .closed-eye {
  opacity: 0;
  height: 0;
}


@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 0;
    stroke-dasharray: 150.6 100.4;
  }
  50% {
    stroke-dasharray: 1 250;
  }
  100% {
    stroke-dashoffset: 502;
    stroke-dasharray: 150.6 100.4;
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 0;
    stroke-dasharray: 150.6 100.4;
  }
  50% {
    stroke-dasharray: 1 250;
  }
  100% {
    stroke-dashoffset: 502;
    stroke-dasharray: 150.6 100.4;
  }
}

@-webkit-keyframes spinner-in {
  0% {
    opacity: 0;
  }
  20%, 80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes spinner-in {
  0% {
    opacity: 0;
  }
  20%, 80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>